import React, { useEffect, useState } from "react";
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";
import CommissonPage from "../../../../entities/DashboardPage/HRModule/CommissonPage";

const Commisson = () => {
  const { showAlert } = useAlert();
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);

  const [leaveType, setLeaveType] = useState([]);
  const [employeeData, setEmployeeData] = useState();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sort, setSort] = useState("");
  const [empData, setempData] = useState([]);
  const [depData, setDepData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getLeaveManagementLists("", "", page);
      getLeaveType();
    }
  }, [page, permission])

  useEffect(() => {
    getAllDepartmentList();
    getDepartment();
  }, [])

  const getLeaveManagementLists = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getCommissionList(text, sort, page);
      if (result?.success) {
        let commissions = result?.data?.commissions || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.commission?.isView === true;
          const hasEditPermission = permission?.commission?.isEdit === true;
          
          // If employee has edit permission, show all commissions (like admin)
          if (hasEditPermission) {
            setTotal(result?.data?.total);
          } else if (hasViewPermission) {
            // If only view permission, show only own data
            commissions = commissions.filter((comm) => comm?.employee?._id === employeeId || comm?.employee?.userId === employeeId);
            setTotal(commissions.length);
          } else {
            // No view permission, show nothing
            commissions = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.total);
        }
        
        setData(commissions);
        setFilteredData(commissions);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getAllApprovedCommission = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getApprovedCommission();
      if (result?.success) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const SearchEmployee = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getLeaveType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAccountLeaveType();
      if (result?.success) {
        setLeaveType(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleLeaveApply = async (employee, commissionName, bonus, fromDate, toDate, fixed, description) => {
    setLoading(true);
    try {
      const result = await AuthService.handleApplyCommission(employee, commissionName, bonus, fromDate, toDate, fixed, description);
      if (result?.success) {
        showAlert(result?.message, "success");
        getLeaveManagementLists()
        setTimeout(() => setOpen(false), 1500);
      } else {
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const handleFilter = (text) => {
    setSearchText(text);
    getLeaveManagementLists(text, sort);
  };

  const handleSort = (sortOption) => {
    setSort(sortOption);
    getLeaveManagementLists(searchText, sortOption);
  };

  const getAllDepartmentList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllDepartmentList();
      if (result?.success) {
        setempData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const DepartmentPayroll = async (department) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handlePayrollDepartmemt(department);
      if (result?.success) {
        setDepData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const DeleteCommission = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.commissonDelete(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists("", "", page);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateCommisson = async (commissionName,
    bonus,
    fromDate,
    toDate,
    fixed,
    description,
    id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.CommissonUpdate(commissionName,
        bonus,
        fromDate,
        toDate,
        fixed,
        description,
        id);
      if (result?.success) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleRequest = async (id, status) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleCommissionRequest(id, status);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        setTimeout(() => setOpen(false), 1500);
        getLeaveManagementLists()
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }
  return (
    <CommissonPage role={role} handleRequest={handleRequest} getApprovedCommission={getAllApprovedCommission} permission={permission} page={page} total={total} setPage={setPage} handleEmployee={SearchEmployee} loading={loading} employeeData={employeeData} data={filteredData.length > 0 ? filteredData : data} open={open} setOpen={setOpen} getLeaveType={leaveType} handleLeaveApply={handleLeaveApply} handleFilter={handleFilter} handleSort={handleSort} getLeaveManagementLists={getLeaveManagementLists} empData={empData} depData={depData} DepartmentPayroll={DepartmentPayroll} departmentData={departmentData} DeleteCommission={DeleteCommission} updateCommisson={updateCommisson} />
  )

}

export default Commisson;
